import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RestrictionRules } from '@app/pages/order-editing/order-editing-rules.config';
import { OrderEditingService } from '@app/pages/order-editing/order-editing.service';
import { ShopService } from '@app/services/shops/shop.service';

@Component({
  selector: 'order-editing-form-edits',
  standalone: false,
  templateUrl: './order-editing-form-edits.component.html',
  styleUrl: './order-editing-form-edits.component.scss',
})
export class OrderEditingFormEditsComponent implements OnInit {
  restrictionsRules = [...RestrictionRules];
  entities = [...RestrictionRules.map((rule) => rule.entity)];
  destroyRef = inject(DestroyRef);

  shippingAddressControl = this.orderEditingService.form.get('template.edits.customerDetails.shippingAddress');

  constructor(
    public orderEditingService: OrderEditingService,
    public shopService: ShopService,
  ) {}

  ngOnInit() {
    this.listenToShippingAddressChange();
  }

  private listenToShippingAddressChange() {
    this.orderEditingService.form
      .get('template.edits.customerDetails.shippingAddress')
      .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        this.handleShippingAddressChange(value);
      });
  }

  private handleShippingAddressChange(allowShippingAddressEdit: boolean) {
    const editPhoneControl = this.orderEditingService.form.get('template.edits.customerDetails.allowEditPhone');
    const editEmailControl = this.orderEditingService.form.get('template.edits.customerDetails.allowEditEmail');
    const editDestinationCountryControl = this.orderEditingService.form.get(
      'template.edits.customerDetails.allowChangingDestinationCountry',
    );
    if (!allowShippingAddressEdit) {
      editEmailControl?.value ? editEmailControl.setValue(false) : null;
      editPhoneControl?.value ? editPhoneControl.setValue(false) : null;
      editDestinationCountryControl?.value ? editDestinationCountryControl.setValue(false) : null;
    }
  }
}
